<template>
  <div class="container">
      <div class="row">
          <div class="col-md-12">
              <div class="error-template">
                  <h1>Oops!</h1>
                  <h2>404 Not Found</h2>
                  <div class="error-details">
                    Sorry, an error has occured, Requested page not found!
                  </div>
                  <div class="error-actions">
                    <a href="javascript:;" @click="goBack" class="btn btn-primary btn-lg"><span class="glyphicon glyphicon-home"></span>Take Me Home</a>
                    <a href="javascript:;" @click="goBack" class="btn btn-default btn-lg"></a>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
